import { StyleSheet } from 'aphrodite'

import main from './main'
import welcome from './welcome'
import perks from './perks'
import mission from './mission'
import stats from './stats'
import signup from './signup'
import reviews from './reviews'

export default {
  main: StyleSheet.create(main),
  welcome: StyleSheet.create(welcome),
  perks: StyleSheet.create(perks),
  mission: StyleSheet.create(mission),
  stats: StyleSheet.create(stats),
  signup: StyleSheet.create(signup),
  reviews: StyleSheet.create(reviews)
}



// WEBPACK FOOTER //
// ./src/components/Home/style/index.js